import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateLocationAccountingDetailsRequest extends BaseUpdateRequest {
    externalAccountingSystemId = '';
}
